import { useState, useRef, useEffect } from "react";

const SearchDropdown = ({ options, onSelect, batch }) => {
  const [search, setSearch] = useState("");
  const [filteredOptions, setFilteredOptions] = useState(options);
  const [selected, setSelected] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearch(value);
    if (value === "") {
      setFilteredOptions(options);
    } else {
      setFilteredOptions(
        options.filter((option) => {
          const label = typeof option === "object" ? option.name : option;
          return label.toLowerCase().includes(value.toLowerCase());
        })
      );
    }
    setIsOpen(true);
  };

  const handleSelect = (option) => {
    const label = typeof option === "object" ? option.name : option;
    const value = typeof option === "object" ? option._id : option;

    setSelected(value);
    setSearch(label); // Show name in input (or string itself)
    setIsOpen(false);
    onSelect(option); // Return _id if object, or string itself
  };
  useEffect(() => {
    setFilteredOptions(options);
  }, [options]);

  return (
    <div
      className="relative w-64 xs:w-52"
      ref={dropdownRef}
      key={batch || "Dropdown"}
    >
      <input
        type="text"
        value={search}
        onChange={handleSearch}
        onFocus={() => setIsOpen(true)}
        placeholder="Search..."
        className="shadow-inner w-full p-2 xs:p-1 xs:text-sm border border-gray-300 rounded-md focus:border-pink-800 focus:bg-white focus:outline-none"
      />
      {isOpen && (
        <ul className="absolute w-full bg-white border border-gray-300 mt-1 rounded shadow max-h-40 overflow-auto">
          {filteredOptions.length > 0 ? (
            filteredOptions.map((option, index) => {
              const label = typeof option === "object" ? option.name : option;
              return (
                <li
                  key={typeof option === "object" ? option._id : index}
                  className="p-2 cursor-pointer hover:bg-gray-200"
                  onClick={() => handleSelect(option)}
                >
                  {label}
                </li>
              );
            })
          ) : (
            <li className="p-2 text-gray-500">No results found</li>
          )}
        </ul>
      )}
    </div>
  );
};

export default SearchDropdown;
